import api from '@api';

const getFileData = async (id: number): Promise<string> => {
    const res: { data: string } = await api('get', `api/secure/files/${id}`);
    return res.data;
};

export default getFileData;
